import { store } from 'store/index'
import { User } from 'store/modules/users'

export class StartCheckinButtonVm {
  onClick = async (userId: string, currentUserId: string, source?: string) => {
    await store.checkins.create(
      {
        assessor: currentUserId,
        author: userId,
        initiated_by: 'assessor',
      },
      { source }
    )
  }

  // Returns true when the org uses joint_review_only AND the IC's team has
  // joint review enabled. In this case the manager should see the checkin form
  // modal (with optional toggle or required banner) instead of a direct API call.
  isJointReviewApplicable(user: User): boolean {
    const org = store.currentUser?.org
    return !!(
      org?.checkinStartType === 'joint_review_only' &&
      user.position?.team?.jointReviewEnabled
    )
  }

  tooltipContent(user: User) {
    if (!user.position) {
      return `${user.fname} requires a position to start a Check-in`
    }

    if (user.position?.team?.isDraft) {
      return `${user.fname} is assigned to a draft team. Please publish the team before starting a Check-in for ${user.fname}.`
    }
  }
}
